/* @flow */
import React from 'react';
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import Image from 'components/Image.jsx';

import './styles/TitleHeader.scss';

class TitleHeader extends React.Component {
  static propTypes = {
    bottomMargin: React.PropTypes.oneOf(['xxlarge', 'xlarge', 'large', 'medium', 'small', 'none']),
    textAlign: React.PropTypes.oneOf(['left', 'center', 'right']),
    image: React.PropTypes.string,
    imageClassName: React.PropTypes.string,
    glyph: React.PropTypes.string,
    title: React.PropTypes.string.isRequired,
    titleColor: React.PropTypes.oneOf(['pitch', 'brand']),
    subtext: React.PropTypes.node,
    subtle: React.PropTypes.bool, // Makes the text colour of the subtext lighter
    size: React.PropTypes.oneOf(['xxlarge', 'xlarge', 'large', 'medium', 'small']),
    action: React.PropTypes.node,
  };

  static propClasses = {
    bottomMargin: {
      xxlarge: 'TitleHeader--bottomMargin--xxlarge',
      xlarge: 'TitleHeader--bottomMargin--xlarge',
      large: 'TitleHeader--bottomMargin--large',
      medium: 'TitleHeader--bottomMargin--medium',
      small: 'TitleHeader--bottomMargin--small',
      none: 'TitleHeader-bottomMargin-none',
    },
    size: {
      xxlarge: 'TitleHeader--xxlarge',
      xlarge: 'TitleHeader--xlarge',
      large: 'TitleHeader--large',
      medium: 'TitleHeader--medium',
      small: 'TitleHeader--small',
    },
    textAlign: {
      left: 'TitleHeader-left',
      center: 'TitleHeader-center',
      right: 'TitleHeader-right',
    },
    titleColor: {
      pitch: 'TitleHeader-pitch',
      brand: 'TitleHeader-brand',
    },
  };

  static defaultProps = {
    bottomMargin: 'xxlarge',
    size: 'medium',
    textAlign: 'center',
    titleColor: 'pitch',
    subtle: false,
  };

  renderImage() {
    const { image } = this.props;
    if (image) {
      return (
        <Image src={image} className={cx('TitleHeader-img', this.props.imageClassName)} />
      );
    }
    return null;
  }

  renderGlyph() {
    const { glyph } = this.props;
    if (glyph) {
      return (
        <Glyph name={glyph} color="brand" className="TitleHeader-glyph" solo />
      );
    }
    return null;
  }

  renderTitle() {
    const { title } = this.props;
    if (title) {
      return (
        <h2 className={cx('TitleHeader-title', getPropClassesFromInstance(this, ['titleColor']))}>
          {title}
        </h2>
      );
    }
    return null;
  }

  renderSubtext() {
    const { subtext } = this.props;
    if (subtext) {
      return (
        <div
          className={cx(
            'TitleHeader-subtext',
            { 'TitleHeader-subtext--subtle': this.props.subtle },
          )}>
          {subtext}
        </div>
      );
    }
    return null;
  }

  renderAction() {
    const { action } = this.props;
    if (action) {
      return (
        <div className="TitleHeader-action">
          {action}
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <header className={cx('TitleHeader', getPropClassesFromInstance(this), this.props.className)}>
        {this.renderImage()}
        {this.renderGlyph()}
        {this.renderTitle()}
        {this.renderSubtext()}
        {this.props.children}
        {this.renderAction()}
      </header>
    );
  }
}

export default TitleHeader;



// WEBPACK FOOTER //
// ./src/components/TitleHeader.jsx